import React, {useState, useEffect} from 'react';

import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import {makeStyles} from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/cardImagesStyles";
import Button from "components/CustomButtons/Button";
import CloseIcon from '@mui/icons-material/Close';
import CardFooter from "components/Card/CardFooter";
import CardBody from "components/Card/CardBody";
import Card from "components/Card/Card";
import {
    closeButton, infoWindowCarousel,markerInfoCard,
    infoWindowImg,
    markerInfoCardBody, pStyle
} from "assets/jss/material-dashboard-pro-react/components/ShowMarkerCardStyle";
import { getProfilePicture } from "services/ConfigServices";

//require("dotenv").config();
const useStyles = makeStyles(styles);

export function ShowMarkerCard(props) {
    const classes = useStyles();

    const [value, setValue] = useState(0);
    const [showCard, setShowCard] = useState(false);

    useEffect(() => {
        setShowCard(props.showCard)
    }, [])

    const toggleMarkerCard = () => {
        const show = props.show;
        setShowCard(!show);
    };
    const closeCard = () => {
        const show = showCard;
        setShowCard(!show);
    };
    const onChange = (value) => {
        setValue(value)
    };

    return (

        
            <Card style={markerInfoCard}>
                {/* <Button onClick={props.onClose} justIcon style={closeButton} size={'sm'} simple>
                    <CloseIcon/>
                </Button> */}
                <div className={"info-window-img"}>
                    <img
                        className={classes.cardImgTop}
                        data-src="holder.js/100px180/"
                        style={infoWindowImg}
                        src={props.locationInfo.picturecode? getProfilePicture(props.locationInfo.picturecode) : "https://maps.googleapis.com/maps/api/streetview?size=320x180&location="+props.locationInfo.lat+","+props.locationInfo.lng+"&key="+process.env.REACT_APP_GOOGLE_API_KEY}
                        data-holder-rendered="true"
                        alt={"marker-img"}
                    />
                </div>
                <CardBody style={markerInfoCardBody}>
                    <div className={"info-title"}>
                        <h3 style={{color:"#FFFFFF"}}>{props.locationInfo.name}</h3>
                    </div>
                    <div className={"info-content"}
                    >
                        <p style={pStyle}>
                            <span><b> Adresse :</b> {props.locationInfo.address}</span>
                        </p>
                        <p style={pStyle}>
                            <span> <b> Téléphone : </b> {props.locationInfo.phone}</span>
                        </p>
                        <p style={pStyle}>
                            <span> <b> Email :</b> {props.locationInfo.email}</span>
                        </p>
                        {/* <p style={pStyle}>
                            <span> <b> Alertes en cours :</b> {props.locationInfo.alertcount}</span>
                        </p>
                        <p style={pStyle}>
                            <span> <b> Actions à réaliser :</b> {props.locationInfo.actions}</span>
                        </p> */}
                        {/* <p style={pStyle}>
                            <span> <b> Empreinte carbone :</b> 752 156 kg CO2</span>
                        </p> */}
                        <p style={pStyle}>
                            <span> <b> Consommation électricité :</b> {
                            props.locationInfo[process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_ELEC]?.replace(".",",")

                            } MWh</span>
                        </p>
                        {/* <p style={pStyle}>
                            <span> <b> Consommation par m² :</b> {props.locationInfo[process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_SQUAREMETER]} kWh/m²</span>
                        </p> */}
                        {/* <p style={pStyle}>
                            <span> <b> Evolution de la consommation d'électricité :</b> {props.locationInfo[process.env.REACT_APP_MAPS_SERIE_CONSUMPTION_EVOLDJU]} %</span>
                        </p> */}
                        <p style={pStyle}>
                            <span> <b> Coûts des dépassements :</b> {props.locationInfo[process.env.REACT_APP_MAPS_SERIE_DEPASSEMENT]} €</span>
                        </p>
                        <p style={pStyle}>
                            <Button onClick={props.onSelectionClick}>Selectionner dans l'arbre</Button>
                        </p>
                    </div>
                </CardBody>
            </Card>
   
    );
}

ShowMarkerCard.propTypes = {
    showCard: PropTypes.bool,
    onClose: PropTypes.func,
    locationInfo: PropTypes.object
}